import { ErrorMessage, Field } from "formik";
import React from "react";
import InfoTooltip from "./InfoTooltip";
import { useTheme } from "../Providers/ThemeContext";

const FormField = ({
  name,
  label,
  icon,
  type = "text",
  as,
  rows,
  hasInfo = false,
  infoTitle = "",
  info = "",
  children,
  required = false,
}) => {
  const { colors } = useTheme();
  return (
    <section className="mb-4">
      <div className="flex w-full items-center justify-between">
        <label
          htmlFor={name}
          className="flex items-center text-sm font-medium mb-1"
          style={{ color: colors.text }}
        >
          {
            <span
              className="inline-block mr-2"
              style={{ color: colors.primary }}
            >
              {React.createElement(icon, {
                className: "inline-block",
                style: { color: colors.primary },
              })}
            </span>
          }
          {label}{" "}
          {required && (
            <span className="ml-1" style={{ color: colors.secondary }}>
              *
            </span>
          )}
        </label>
        <div className="flex items-center justify-end">
          {hasInfo && <InfoTooltip title={infoTitle} text={info} />}
        </div>
      </div>

      <Field
        name={name}
        type={type}
        as={as}
        rows={rows}
        className="mt-1 pl-2 block w-full rounded-md shadow-sm transition duration-150 ease-in-out border p-1 border-amber-50"
        style={{
          backgroundColor: colors.background,
          color: colors.text,
          borderColor: colors.border,
        }}
      >
        {children}
      </Field>
      <ErrorMessage
        name={name}
        component="div"
        className="mt-1 text-sm"
        style={{ color: colors.secondary }}
      />
    </section>
  );
};

export default FormField;
